var _path, _g, _g2, _ellipse, _path2, _path3, _ellipse2, _path4, _path5, _path6, _ellipse3, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g3, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _polygon, _path27, _path28, _path29, _path30, _path31, _path32, _g4, _g5, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _g6, _g7, _path46, _path47, _path48, _ellipse4, _path49, _path50, _path51, _path52, _ellipse5, _path53, _path54, _path55, _path56, _path57, _g8, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _g9, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _ellipse6, _g10, _path79, _path80, _path81, _path82, _g11, _g12, _path83, _path84, _path85, _path86, _g13, _g14, _g15, _path87, _path88, _path89, _path90, _g16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "924.812px",
    height: "987.377px",
    viewBox: "0 0 924.812 987.377",
    enableBackground: "new 0 0 924.812 987.377",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4FAFE",
    d: "M924.812,4.941c-89.279,8.908-113.664,96.951-318.279,18.392c-129.667-49.784-208.666-6.581-244,7.612 c-18.525,7.442-35.885,18.273-50.466,32.384c-35.474,34.329-43.92,87.281-28.889,137.007l-0.019,0.008 c7.866,26.648,1.747,58.522-19.034,84.495c-23.338,29.167-58.747,42.875-90.227,38.063c-9.566-1.921-19.49-2.937-29.677-2.937 C64.968,319.965,0,381.049,0,457.745c0,36.083,14.224,68.949,37.537,93.641c17.451,19.517,28.352,47.121,28.352,77.745 c0,25.632-7.635,49.149-20.354,67.581c-20.144,24.085-32.092,54.052-32.092,86.536c0,79.472,71.475,143.894,159.642,143.894 c29.341,0,56.828-7.141,80.453-19.591c38.269-18.017,86.502-28.769,138.936-28.769c79.852,0,149.99,24.922,189.965,62.496 l0.014-0.003c31.732,28.536,74.948,46.101,122.582,46.101c65.035,0,121.841-32.736,152.415-81.449 c9.136-12.482,36.209-44.6,67.362-35.686V4.941z"
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#334752",
    d: "M633.504,446.959c-13.688-7.848-35.874-7.479-49.302,0.813l-183.89,113.612 c-13.428,8.295-13.208,21.499,0.483,29.345l154.374,88.46c13.69,7.848,35.877,7.478,49.302-0.814l183.892-113.611 c13.426-8.294,13.206-21.502-0.484-29.346L633.504,446.959z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E4EB",
    d: "M582.611,286.322l-162.823-93.708c-1.948-1.122-3.762-1.462-5.261-1.131 c-3.663,0.51-8.321,3.419-13.718,6.245c-0.018,0.011-0.034,0.027-0.051,0.04c-1.733,0.956-2.816,3.052-2.816,6.052v366.723 c0,5.908,4.189,13.156,9.311,16.104l162.825,93.705c1.704,0.98,3.299,1.354,4.677,1.215c2.516-0.082,5.682-1.124,9.679-3.101 c3.42-1.833,5.063-3.231,5.856-4.204c0.049-0.059,0.098-0.122,0.146-0.181c0.007-0.009,0.013-0.02,0.02-0.027 c0.924-1.134,1.467-2.791,1.467-4.905V302.425C591.923,296.515,587.733,289.269,582.611,286.322z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#314584",
    d: "M579.388,308.244c0-5.908-4.189-13.156-9.31-16.104l-162.825-93.705 c-5.121-2.949-9.311-0.526-9.311,5.384v366.723c0,5.908,4.189,13.156,9.311,16.104l162.825,93.705 c5.12,2.946,9.31,0.524,9.31-5.384V308.244z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5767C7",
    d: "M475.417,602.636c-1.966-1.133-3.577-0.202-3.577,2.069v7.522c0,2.271,1.611,5.057,3.577,6.188 l19.259,11.084c1.966,1.131,3.577,0.201,3.577-2.068v-7.526c0-2.27-1.611-5.054-3.577-6.187L475.417,602.636z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C7E6FF",
    d: "M407.033,225.169c-2.132-1.228-3.879-0.218-3.879,2.243v321.412c0,2.463,1.747,5.481,3.879,6.71 l162.349,93.432c2.133,1.228,3.88,0.219,3.88-2.244v-321.41c0-2.463-1.747-5.481-3.88-6.71L407.033,225.169z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5768C8",
    d: "M466.56,242.216c-1.45-0.835-2.638-0.147-2.638,1.523v2.635c0,1.674,1.188,3.724,2.638,4.559 l45.612,26.249c1.449,0.834,2.634,0.151,2.634-1.524v-2.634c0-1.672-1.185-3.723-2.634-4.558L466.56,242.216z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#334787",
    d: "M581.468,458.984c0,2.147,1.494,2.981,3.321,1.857l1.415-0.871c1.827-1.124,3.322-3.8,3.322-5.942 v-15.299c0-2.145-1.495-2.979-3.322-1.855l-1.415,0.869c-1.827,1.127-3.321,3.8-3.321,5.944V458.984z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#334787",
    d: "M479.731,229.538c-1.722-0.99-4.512-0.948-6.201,0.09l-0.3,0.184c-1.69,1.042-1.666,2.702,0.056,3.693 l36.571,21.047c1.721,0.99,4.51,0.95,6.202-0.092l0.296-0.183c1.69-1.041,1.668-2.701-0.054-3.69L479.731,229.538z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#334787",
    d: "M581.468,410.693c0,2.146,1.494,2.981,3.321,1.856l1.415-0.872c1.827-1.123,3.322-3.798,3.322-5.942 v-61.251c0-2.145-1.495-2.979-3.322-1.854l-1.415,0.871c-1.827,1.124-3.321,3.798-3.321,5.941V410.693z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.8384 0.545 -0.545 -0.8384 884.9379 175.5593)",
    fill: "#5768C8",
    cx: 416.444,
    cy: 218.961,
    rx: 4.305,
    ry: 6.314
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5768C8",
    d: "M424.586,227.394c0.485,0.748,1.294,1.086,1.803,0.753c0.511-0.331,0.53-1.205,0.044-1.952 c-0.486-0.751-1.295-1.087-1.804-0.756S424.101,226.646,424.586,227.394z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5768C8",
    d: "M562.953,306.916c0.718,1.104,1.911,1.604,2.663,1.112c0.754-0.487,0.784-1.78,0.065-2.885 c-0.72-1.108-1.912-1.606-2.665-1.117C562.263,304.516,562.233,305.81,562.953,306.916z"
  }))), /*#__PURE__*/React.createElement("g", null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    fill: "#334752",
    cx: 258.606,
    cy: 578.396,
    rx: 27.752,
    ry: 16.117
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C3D0D8",
    d: "M284.249,549.578l-12.253-1.008l-8.73-0.783l-17.961,0.562l-11.416,0.782l-1.847,1.231l3.214,26.365 c0,0.008-0.002,0.017-0.002,0.027c0,7.345,10.253,13.299,22.903,13.299c12.261,0,22.27-5.594,22.873-12.625 c0.011-0.016,0.031-0.039,0.031-0.039L284.249,549.578z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDF2F6",
    d: "M284.259,550.063c0,7.563-11.687,13.69-26.102,13.69c-14.418,0-26.102-6.128-26.102-13.69 c0-7.56,11.684-13.69,26.102-13.69C272.572,536.373,284.259,542.504,284.259,550.063z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    fill: "#334752",
    cx: 258.157,
    cy: 550.063,
    rx: 17.011,
    ry: 8.922
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8296,
    y1: 510.9922,
    x2: 263.4845,
    y2: 552.9221
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFF57A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#54D169"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M273.36,504.887c-0.181-8.248-6.912-14.882-15.203-14.882c-8.295,0-15.022,6.634-15.204,14.882 h-0.016v45.068h0.009c0,0.038-0.009,0.071-0.009,0.108c0,4.409,6.813,7.985,15.22,7.985c8.405,0,15.219-3.576,15.219-7.985 c0-0.037-0.009-0.07-0.01-0.108h0.01v-45.068H273.36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.519,
    y1: 498.2114,
    x2: 268.1569,
    y2: 540.8837
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFF57A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#54D169"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M258.157,490.005c-8.295,0-15.022,6.634-15.204,14.882h-0.016v0.325 c1.57,1.05,3.545,1.866,6.25,3.002c9.251,3.88,14.325,0,18.8,4.028c1.862,1.675,3.745,3.663,5.389,5.729v-13.085h-0.016 C273.18,496.639,266.448,490.005,258.157,490.005z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.5293,
    y1: 527.3535,
    x2: 270.2571,
    y2: 566.2996
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFF57A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#54D169"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M273.376,550.063c0-0.037-0.009-0.07-0.01-0.108h0.01v-36.816 c-1.018,4.526-2.846,8.835-9.568,10.743c-12.086,3.432-12.833,11.488-20.591,16.713c-0.098,0.064-0.185,0.121-0.28,0.184v9.177 h0.009c0,0.038-0.009,0.071-0.009,0.108c0,4.409,6.813,7.985,15.22,7.985C266.563,558.049,273.376,554.473,273.376,550.063z"
  }))), /*#__PURE__*/React.createElement("g", null, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    fill: "#334752",
    cx: 723.687,
    cy: 669.712,
    rx: 27.752,
    ry: 16.114
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#C3D0D8",
    d: "M749.333,640.895l-12.256-1.009l-8.729-0.783l-17.96,0.56l-11.416,0.784l-1.847,1.23l3.213,26.363 c0,0.012,0,0.02,0,0.029c0,7.345,10.252,13.3,22.901,13.3c12.261,0,22.27-5.595,22.871-12.628 c0.014-0.013,0.031-0.039,0.031-0.039L749.333,640.895z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDF2F6",
    d: "M749.343,641.381c0,7.558-11.688,13.688-26.103,13.688c-14.417,0-26.103-6.13-26.103-13.688 c0-7.563,11.686-13.692,26.103-13.692C737.654,627.688,749.343,633.817,749.343,641.381z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fill: "#334752",
    d: "M740.249,641.381c0,4.927-7.616,8.921-17.009,8.921c-9.397,0-17.011-3.994-17.011-8.921 c0-4.932,7.613-8.923,17.011-8.923C732.633,632.458,740.249,636.449,740.249,641.381z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 719.9111,
    y1: 602.3057,
    x2: 728.5659,
    y2: 644.235
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFF57A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#54D169"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M738.443,596.202c-0.183-8.25-6.913-14.884-15.203-14.884c-8.293,0-15.023,6.634-15.206,14.884 h-0.016v45.066h0.012c0,0.036-0.012,0.074-0.012,0.112c0,4.407,6.815,7.98,15.222,7.98c8.405,0,15.22-3.573,15.22-7.98 c0-0.038-0.012-0.076-0.012-0.112h0.012v-45.066H738.443z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 721.6006,
    y1: 589.5244,
    x2: 733.2396,
    y2: 632.2006
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFF57A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#54D169"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M723.24,581.318c-8.293,0-15.023,6.634-15.206,14.884h-0.016v0.324 c1.572,1.052,3.546,1.869,6.25,3.004c9.251,3.876,14.324,0,18.803,4.027c1.859,1.674,3.744,3.659,5.389,5.729v-13.085h-0.017 C738.261,587.952,731.53,581.318,723.24,581.318z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 721.6113,
    y1: 618.6689,
    x2: 735.3384,
    y2: 657.613
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFF57A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#54D169"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M738.46,641.381c0-0.038-0.012-0.076-0.012-0.112h0.012v-36.814 c-1.02,4.525-2.85,8.833-9.568,10.743c-12.087,3.431-12.832,11.489-20.592,16.711c-0.099,0.064-0.185,0.122-0.281,0.186v9.175 h0.012c0,0.036-0.012,0.074-0.012,0.112c0,4.407,6.815,7.98,15.222,7.98C731.646,649.361,738.46,645.788,738.46,641.381z"
  }))), /*#__PURE__*/React.createElement("g", null, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "#334752",
    d: "M659.174,729.823l-33.823-19.382c-0.195-0.11-0.396-0.214-0.607-0.31l-32.711-18.744 c-3-1.719-7.861-1.641-10.801,0.18l-40.289,24.892c-2.943,1.815-2.895,4.708,0.105,6.427l33.822,19.382 c0.195,0.113,0.397,0.216,0.606,0.312l32.712,18.744c2.998,1.719,7.858,1.639,10.801-0.178l40.289-24.89 C662.221,734.437,662.173,731.543,659.174,729.823z"
  })), /*#__PURE__*/React.createElement("g", null, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E4EB",
    d: "M619.206,703.227c0-2.112-1.496-4.699-3.324-5.751l-68.789-39.589c-0.739-0.425-1.424-0.532-1.979-0.374 c-1.821,0.366-4.278,2.189-4.278,2.189l-0.003,0.007c-0.567,0.362-0.917,1.088-0.917,2.105v53.81 c0,2.109,1.497,4.699,3.323,5.752l68.789,39.587c0.605,0.349,1.171,0.481,1.66,0.437c0.563-0.013,1.316-0.169,2.189-0.695 c1.72-1.033,2.491-1.397,2.881-2.017c0.282-0.4,0.447-0.958,0.447-1.653V703.227z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 588.0742,
    y1: 687.46,
    x2: 552.9135,
    y2: 764.8137
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#15EDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#029CF5"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M615.354,705.228c0-2.108-1.497-4.695-3.325-5.749l-68.789-39.587 c-1.826-1.053-3.323-0.188-3.323,1.923v53.81c0,2.109,1.497,4.699,3.323,5.752l68.789,39.587 c1.828,1.051,3.325,0.188,3.325-1.923V705.228z"
  })))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE600",
    d: "M586.785,726.846c3.888,5.984,10.353,8.687,14.434,6.036c4.079-2.653,4.235-9.653,0.343-15.639 c-3.889-5.986-10.35-8.691-14.434-6.037C583.05,713.854,582.896,720.857,586.785,726.846z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 582.6182,
    y1: 722.498,
    x2: 567.1154,
    y2: 756.86
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#46EEAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2CBFC7"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M615.354,759.04v-8.717l-15.31-8.623l-14.385-24.613l-7.459,5.859l-15.13-30.047 c0,0-16.079,10.084-23.154,14.388v8.337c0,2.109,1.497,4.699,3.323,5.752l68.789,39.587 C613.856,762.014,615.354,761.15,615.354,759.04z"
  })))), /*#__PURE__*/React.createElement("g", null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#334752",
    d: "M160.326,704.579l17.333-10.665c2.161-1.329,2.181-3.414,0.132-4.737l-31.729-18.26 c-2.275-1.308-5.962-1.252-8.197,0.122l-17.333,10.665c-2.159,1.328-2.182,3.414-0.134,4.732l31.733,18.261 C154.403,706.007,158.092,705.952,160.326,704.579z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.6011,
    y1: 568.8398,
    x2: 174.6194,
    y2: 522.4346
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8A980"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDF75"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_9_)",
    d: "M189.574,528.695c-1.175,3.859-3.792,12.975-6.64,18.499c-2.676,5.198-6.747,11.06-8.146,10.947 c-1.176-0.196-0.294-0.604-1.581-0.407c-1.288,0.195-6.548,4.281-5.26,5.261c-0.015,0.055,0,0.142,0,0.142 s2.749,2.708,6.618,3.56c0.188,0.078,0.395,0.125,0.608,0.125c0.381,0,0.727-0.142,1.002-0.363 c1.694-0.819,11.527-6.329,15.357-25.118c0.112-0.28,1.456-7.665,2.126-15.555C193.658,524.61,190.75,524.834,189.574,528.695z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.895,
    y1: 691.6563,
    x2: 122.3505,
    y2: 598.2474
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8A980"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDF75"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_)",
    d: "M136.302,633.034c0.076,0.299,0.896,9.025-1.641,25.142c-2.536,16.115-2.61,16.75-2.908,19.883 c-0.135,2.059,3.579,4.216,6.713,5.224c3.134,1.006,9.681,1.621,12.59-1.398c1.119-2.072-0.559-3.133-0.559-3.133 s-2.872,0.297-4.151,0.267c-0.976-0.052-4.215-0.267-3.851-1.778s3.638-19.25,4.421-28.594 c0.784-9.346,1.287-19.136,1.287-19.136l-2.015-4.645l-12.086-1.513L136.302,633.034z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C4755",
    d: "M154.721,679.311c-1.931-0.98-4.42-0.784-4.42-0.784s-1.127,0.168,0.279,1.064 c0.798,0.336,1.18,3.062-3.385,3.748c-3.883,0.61-4.95,0.474-6.965-0.063c-0.041-0.01-0.078-0.021-0.127-0.036 c-7.758-2.228-7.567-7.643-8.426-6.71c-1.06,1.152-2.163,2.151-2.163,4.81c0,1.285,0.185,2.837,0.784,3.884 c0.937,2.037,1.445,5.053,1.454,5.086v2.665c0,0.628,0.419,0.865,1.045,0.865c0.626,0,1.222-0.237,1.222-0.865v-3.446 c0.172-1.798,0.793-3.094,0.793-3.094s0.746-1.547,1.732-0.057c1.008,1.524,2.464,3.861,5.84,3.88 c3.376,0.019,5.679-1.176,9.624-4.03C155.955,683.375,156.652,680.288,154.721,679.311z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 167.1147,
    y1: 696.2813,
    x2: 137.5707,
    y2: 602.8739
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8A980"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDF75"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M151.522,637.659c0.076,0.3,0.895,9.027-1.641,25.144c-2.537,16.112-2.609,16.749-2.908,19.88 c-0.135,2.061,3.58,4.217,6.713,5.225c3.132,1.008,9.68,1.622,12.589-1.399c1.12-2.068-0.56-3.133-0.56-3.133 s-2.873,0.298-4.15,0.271c-0.976-0.054-4.215-0.271-3.851-1.783c0.363-1.511,3.637-19.247,4.419-28.593 c0.785-9.343,1.287-19.137,1.287-19.137l-2.014-4.646l-12.087-1.509L151.522,637.659z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C4755",
    d: "M169.942,683.935c-1.932-0.979-4.421-0.784-4.421-0.784s-1.128,0.169,0.28,1.062 c0.797,0.337,1.18,3.063-3.385,3.752c-3.885,0.61-4.951,0.474-6.966-0.059c-0.041-0.013-0.078-0.024-0.127-0.043 c-7.758-2.226-7.567-7.639-8.426-6.708c-1.062,1.154-2.164,2.155-2.164,4.813c0,1.282,0.185,2.834,0.783,3.88 c0.937,2.04,1.445,5.055,1.455,5.089v2.666c0,0.623,0.419,0.861,1.044,0.861c0.627,0,1.222-0.238,1.222-0.861v-3.451 c0.173-1.795,0.792-3.091,0.792-3.091s0.747-1.549,1.733-0.058c1.009,1.523,2.463,3.861,5.841,3.881 c3.377,0.019,5.679-1.176,9.625-4.03C171.174,688.002,171.872,684.913,169.942,683.935z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.1382,
    y1: 554.0752,
    x2: 120.3938,
    y2: 554.5601
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8A980"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDF75"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_12_)",
    d: "M136.453,554.9c0,3.677,7.666,6.659-6.295,6.659c-3.477,0-5.756-3.047-6.464-6.659 c-2.461-12.592,2.987-6.659,6.464-6.659C133.634,548.241,136.453,551.221,136.453,554.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.7339,
    y1: 531.0313,
    x2: 130.7299,
    y2: 530.5836
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#46EEAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2CBFC7"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_13_)",
    d: "M137.87,536.863c0-1.046-3.879-14.771-3.879-14.997c0-0.165-1.428-3.23-2.172-4.813 c0.668-3.621,8.495-11.451-1.385-7.966c-3.636,1.312-4.793,3.184-5.842,7.253c-0.483,1.878-0.588,3.67-0.375,5.114 c0.242,1.12,0.249,9.308-1.12,16.005c-1.417,6.939-2.312,12.533,0.3,14.102c2.611,1.568,5.894,1.416,8.28,1.192 c2.388-0.224,7.982-2.61,7.982-2.61S137.87,537.908,137.87,536.863z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.1475,
    y1: 503.041,
    x2: 169.8647,
    y2: 625.9938
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#46EEAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2CBFC7"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_14_)",
    d: "M164.729,564.169c-2.538-4.102-2.538-4.029-2.538-6.49c0-2.462,0.15-10.369,0.972-17.084 c0.819-6.716,3.132-8.656,2.685-13.58c-0.449-4.922-0.002-9.251-8.878-13.057c-3.956-1.024-13.865-5.276-17.402-5.607 c-0.942-0.253-1.95-0.398-3.004-0.398c-4.439,0-8.142,2.444-8.993,5.687c-2.006,5.171-0.213,12.491,0.32,21.283 c0.558,9.233,4.645,21.488,4.869,22.496c0.224,1.007,0.783,2.072-0.169,3.188c-4.197,4.925-5.203,11.92-5.203,11.92 s-0.003,0.074-0.008,0.201c-0.208,1.215-0.327,2.472-0.327,3.771c0,0.708,0.043,1.403,0.105,2.088 c-0.042,2.349,0.865,4.315,3.083,11.565c2.575,12.42,0.841,40.175,0.841,40.175c0,4.233,7.966,7.667,17.792,7.667 c9.828,0,17.795-3.434,17.795-7.667c0,0,0.224-40.008,0.448-45.716C167.341,578.905,167.266,568.273,164.729,564.169z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C4755",
    d: "M185.561,546.238c-0.536,1.375-2.102,2.063-3.479,1.526l-24.781-9.665 c-1.376-0.539-2.063-2.103-1.526-3.478l13.46-34.512c0.537-1.376,2.102-2.063,3.478-1.528l24.782,9.665 c1.375,0.536,2.061,2.104,1.525,3.48L185.561,546.238z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.9946,
    y1: 501.5078,
    x2: 176.5398,
    y2: 554.3292
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#15EDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#029CF5"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_15_)",
    points: "183.06,545.263 183.057,545.263 183.05,545.261 158.276,535.596 171.739,501.086  196.519,510.753 183.057,545.261 183.06,545.263  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.1719,
    y1: 526.5195,
    x2: 182.1576,
    y2: 561.8844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#46EEAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2CBFC7"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_16_)",
    d: "M172.731,554.042c0,0-1.454-3.162-3.785-8.04c-2.407-5.035-4.581-10.063-3.826-13.252 c0.54-2.272,0.707-4.988,0.76-6.37c0.028-0.332,0.042-0.666,0.042-1.006c0-5.213-3.273-9.438-7.311-9.438 c-3.859,0-7.012,3.861-7.286,8.753c-0.008,0.01-0.017,0.018-0.026,0.033c-0.745,7.05,4.179,18.408,5.858,21.279 c1.678,2.872,5.521,11.64,6.304,13.469c0.784,1.826,3.283,4.177,5.075,4.551c1.79,0.372,4.665-3.741,5.707-5.223 C174.951,557.79,172.731,554.042,172.731,554.042z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.3799,
    y1: 514.0039,
    x2: 142.2647,
    y2: 495.7587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8A980"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDF75"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_17_)",
    d: "M153.746,504.071l-0.503-0.755l-2.407-2.266l-4.952-0.28l-3.889,0.866 c0,0,0.504,1.093,0.281,3.75c-0.317,2.72-0.691,3.813-0.881,4.219c-0.125,0.164-0.213,0.346-0.253,0.544 c-0.267,1.396,1.906,2.989,4.858,3.559c2.953,0.566,5.562-0.103,5.83-1.5c0.025-0.136,0.022-0.27,0.005-0.406 c0.043-0.429,0.085-1.096,0.122-2.189C152.152,506.337,153.746,504.071,153.746,504.071z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.3774,
    y1: 507.7549,
    x2: 155.7132,
    y2: 464.5565
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8A980"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDF75"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_18_)",
    d: "M167.231,478.974c0.135,1.393,0.188,6.894,0.188,8.414c0,8.652-2.482,15.146-6.79,16.32 c-13.692,3.61-17.011-3.49-17.011-12.144c0-8.65,15.752-19.845,18.616-19.845C164.594,471.72,166.604,472.455,167.231,478.974z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.1938,
    y1: 470.2661,
    x2: 155.0859,
    y2: 500.3326
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2C4755"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#334752"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_19_)",
    d: "M167.641,476.383c0,0.775-0.054,3.338-0.838,3.321c-3.394-0.088-5.966,1.484-4.943,5.648 c0.696,2.854-0.136,7.95-3.543,15.461c-0.961,2.123,1.269,5.523-0.222,5.523c-0.522,0-1.735-0.579-1.754-3.655 c-0.027-4.01,1.977-7.016,2.202-7.984c2.23-8.142-4.02-7.119-4.926-5.704c-1.257,1.966-3.468,4.514,0.187,8.019 c3.031,2.906-5.291,7.071-7.666,6.416c-6.364-1.756-6.492,1.371-7.61,2.798c-5.759,7.344-4.683-24.178-4.683-29.843 s6.336-9.662,15.669-9.662C158.847,466.721,167.641,470.718,167.641,476.383z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 133.6011,
    y1: 474.9165,
    x2: 151.0603,
    y2: 489.0929
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7C6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5317F"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_20_)",
    d: "M145.707,479.22c0,4.181-3.047,7.572-6.809,7.572c-3.76,0-6.808-3.392-6.808-7.572 c0-4.186,3.047-7.575,6.808-7.575C142.66,471.645,145.707,475.034,145.707,479.22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.6724,
    y1: 494.0322,
    x2: 139.1488,
    y2: 522.6815
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2C4755"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#334752"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_21_)",
    d: "M142.201,492.015c1.118-9.104,1.166-10.548,0.915-12.004c-0.002-0.003-0.002-0.003-0.003-0.003 c-0.372-3.079-2.681-5.452-5.481-5.452c-2.777,0-4.282,2.487-5.47,5.37h-0.014c0,0-6.435,14.997-5.092,29.769 c1.343,14.774,1.12,15.595,8.506,28.502c2.982,6.193,3.282,6.788,3.133,9.177c-0.15,2.388,1.79,3.656,2.163-1.269 c0.374-4.926,0.747-11.041-2.61-21.04c-1.94-5.969-1.493-11.414-0.374-15.892C138.994,504.696,140.561,500.813,142.201,492.015 z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#334752",
    d: "M524.361,446.976c-2.563-1.475-4.657-0.262-4.657,2.692v119.87c0,2.955,2.095,6.578,4.657,8.051 l42.615,24.527c2.562,1.474,4.655,0.264,4.655-2.691V479.552c0-2.953-2.094-6.576-4.655-8.051L524.361,446.976z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E4EB",
    d: "M558.77,477.208l-42.616-24.525c-1.292-0.746-2.462-0.802-3.309-0.299 c-4.158,1.679-5.975,2.761-6.626,3.199c-0.882,0.469-1.435,1.521-1.435,3.037v119.872c0,2.954,2.095,6.576,4.654,8.05 l42.617,24.527c0.668,0.384,1.301,0.582,1.875,0.616c0.334,0.046,2.068,0.161,5.121-1.707c1.614-1.018,2.443-1.523,2.852-1.767 c0.113-0.054,0.221-0.117,0.322-0.189c0.024-0.016,0.035-0.021,0.035-0.021l0.002-0.007c0.721-0.531,1.163-1.512,1.163-2.865 V485.258C563.426,482.306,561.333,478.682,558.77,477.208z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EDF2F6",
    d: "M509.438,455.929c-2.56-1.476-4.654-0.264-4.654,2.691v119.872c0,2.954,2.095,6.576,4.654,8.05 l42.617,24.527c2.561,1.473,4.655,0.261,4.655-2.692V488.503c0-2.953-2.095-6.577-4.655-8.049L509.438,455.929z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#6A6D89",
    points: "518.064,491.117 537.537,502.321 537.537,492.691 518.064,481.485  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6A6D89",
    points: "549.549,534.776 549.549,525.146 516.05,505.867 516.05,515.499  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6A6D89",
    points: "540.223,533.283 510.378,516.107 510.378,525.74 540.223,542.914  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6A6D89",
    points: "516.05,542.505 549.549,561.784 549.549,552.154 516.05,532.873  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6A6D89",
    points: "510.378,552.746 549.549,575.289 549.549,565.658 510.378,543.115  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6A6D89",
    points: "510.378,556.619 510.378,566.249 529.702,577.372 529.702,567.738  "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#334752",
    d: "M427.817,272.391c-2.561-1.473-4.656-0.26-4.656,2.694v119.872c0,2.953,2.096,6.578,4.656,8.051 l42.615,24.526c2.561,1.473,4.656,0.262,4.656-2.693V304.97c0-2.955-2.096-6.576-4.656-8.051L427.817,272.391z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E4EB",
    d: "M462.226,302.626L419.612,278.1c-1.293-0.744-2.465-0.802-3.312-0.3 c-4.157,1.683-5.975,2.761-6.624,3.199c-0.883,0.472-1.437,1.523-1.437,3.038v119.872c0,2.955,2.095,6.579,4.657,8.052 l42.614,24.527c0.667,0.383,1.302,0.58,1.877,0.617c0.333,0.045,2.069,0.159,5.121-1.71c1.614-1.016,2.442-1.523,2.851-1.765 c0.111-0.057,0.219-0.119,0.321-0.191c0.024-0.013,0.034-0.019,0.034-0.019s0.005-0.007,0.005-0.009 c0.719-0.529,1.161-1.512,1.161-2.863V310.676C466.882,307.723,464.788,304.101,462.226,302.626z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EDF2F6",
    d: "M412.897,281.346c-2.563-1.474-4.657-0.263-4.657,2.69v119.872c0,2.955,2.095,6.579,4.657,8.052 l42.614,24.527c2.562,1.47,4.656,0.26,4.656-2.694V313.922c0-2.953-2.095-6.576-4.656-8.051L412.897,281.346z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#6A6D89",
    points: "421.521,316.534 440.993,327.741 440.993,318.109 421.521,306.903  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6A6D89",
    points: "453.005,360.194 453.005,350.563 419.506,331.284 419.506,340.915  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6A6D89",
    points: "443.681,358.699 413.836,341.524 413.836,351.155 443.681,368.332  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6A6D89",
    points: "419.506,367.925 453.005,387.201 453.005,377.57 419.506,358.291  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6A6D89",
    points: "413.836,378.163 453.005,400.705 453.005,391.075 413.836,368.531  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6A6D89",
    points: "413.836,382.037 413.836,391.667 433.161,402.788 433.161,393.156  "
  }))))), /*#__PURE__*/React.createElement("g", null, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "#334752",
    d: "M568.998,421.216c0.089,0.018,0.181,0.05,0.267,0.057c0.127,0.011,0.244-0.002,0.361-0.015 c0.059-0.005,0.121,0.002,0.178-0.008c0.113-0.022,0.216-0.067,0.32-0.112c0.689-0.287,1.135-1.028,1.135-2.153V354.9 c0-2.044-1.451-4.555-3.226-5.576l-72.515-41.733c-1.044-0.601-1.965-0.543-2.557,0.01c-0.058,0.055-0.115,0.109-0.165,0.173 c-0.058,0.071-0.104,0.152-0.153,0.235c-0.041,0.069-0.083,0.135-0.117,0.211c-0.046,0.107-0.08,0.229-0.113,0.353 c-0.018,0.069-0.045,0.134-0.059,0.209c-0.039,0.209-0.062,0.431-0.062,0.674v64.082c0,2.047,1.45,4.557,3.226,5.576 l39.641,22.816l0.008,0.015l19.969,11.497v-0.017l6.277,3.616l0.232,0.132l6.388,3.677c0.22,0.125,0.432,0.223,0.638,0.293 C568.786,421.181,568.89,421.194,568.998,421.216z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 547.793,
    y1: 297.647,
    x2: 496.7614,
    y2: 432.8358
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#15EDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#029CF5"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_22_)",
    d: "M559.198,354.838l-72.516-41.734c-0.688-0.396-1.328-0.51-1.854-0.383 c-0.254,0.029-0.705,0.286-3.178,1.337c-1.949,0.829-2.828,1.453-3.209,1.789c-0.48,0.375-0.773,1.047-0.773,1.964v64.083 c0,2.046,1.451,4.557,3.226,5.576l60.979,35.112l5.148,2.946l6.387,3.677c0.867,0.495,1.651,0.549,2.232,0.239 c0.381-0.106,1.021-0.309,2.088-0.698c2.064-0.732,3.242-1.647,3.832-2.227c0.532-0.358,0.861-1.053,0.861-2.023v-64.082 C562.423,358.369,560.972,355.859,559.198,354.838z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 524.249,
    y1: 339.2998,
    x2: 504.105,
    y2: 433.7529
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#15EDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#029CF5"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_23_)",
    d: "M554.374,429.571c0.09,0.017,0.182,0.049,0.266,0.057c0.127,0.01,0.244-0.004,0.362-0.014 c0.058-0.005,0.121,0.001,0.177-0.01c0.115-0.02,0.218-0.069,0.321-0.109c0.689-0.289,1.135-1.032,1.135-2.154v-64.083 c0-2.047-1.45-4.557-3.226-5.578l-72.515-41.732c-1.044-0.6-1.966-0.543-2.556,0.009c-0.059,0.056-0.115,0.108-0.166,0.172 c-0.059,0.071-0.105,0.151-0.152,0.238c-0.043,0.066-0.082,0.134-0.117,0.208c-0.047,0.108-0.08,0.231-0.114,0.354 c-0.021,0.07-0.045,0.135-0.058,0.209c-0.039,0.208-0.063,0.431-0.063,0.674v64.083c0,2.046,1.451,4.557,3.226,5.576 l39.641,22.814l0.01,0.016l19.966,11.497v-0.016l6.28,3.614l0.231,0.133l6.387,3.677c0.22,0.125,0.432,0.222,0.638,0.294 C554.16,429.535,554.267,429.548,554.374,429.571z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE600",
    d: "M526.667,387.59c5.444,8.38,14.495,12.165,20.212,8.449c5.712-3.71,5.932-13.516,0.481-21.898 c-5.447-8.381-14.494-12.173-20.213-8.455C521.432,369.397,521.217,379.204,526.667,387.59z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A6D89",
    d: "M552.245,412.869L532.102,378.4l-10.446,8.207l-21.188-42.08c0,0-12.362,7.752-22.798,14.222v23.146 c0,2.046,1.451,4.557,3.226,5.576l39.641,22.814l0.01,0.016l19.966,11.497v-0.016l6.28,3.614l0.231,0.133l6.387,3.677 c0.22,0.125,0.432,0.222,0.638,0.294c0.113,0.035,0.22,0.048,0.327,0.071c0.09,0.017,0.182,0.049,0.266,0.057 c0.127,0.01,0.244-0.004,0.362-0.014c0.058-0.005,0.121,0.001,0.177-0.01c0.115-0.02,0.218-0.069,0.321-0.109 c0.689-0.289,1.135-1.032,1.135-2.154v-11.998L552.245,412.869z"
  })))), /*#__PURE__*/React.createElement("g", null, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "#334752",
    d: "M491.488,567.774c0.058,0.013,0.114,0.032,0.168,0.038c0.08,0.007,0.155-0.003,0.23-0.01 c0.036-0.003,0.076,0,0.112-0.006c0.072-0.016,0.137-0.044,0.203-0.069c0.436-0.182,0.717-0.653,0.717-1.364V525.78 c0-1.296-0.918-2.887-2.041-3.531l-45.925-26.432c-0.659-0.379-1.243-0.343-1.618,0.007c-0.036,0.035-0.072,0.069-0.105,0.109 c-0.035,0.046-0.064,0.097-0.098,0.15c-0.023,0.043-0.051,0.083-0.072,0.132c-0.029,0.069-0.051,0.147-0.07,0.223 c-0.012,0.046-0.029,0.087-0.039,0.135c-0.023,0.133-0.039,0.274-0.039,0.428v40.579c0,1.299,0.918,2.887,2.042,3.534 l25.104,14.449l0.008,0.009l12.644,7.282v-0.01l3.977,2.287l0.147,0.084l4.045,2.33c0.138,0.077,0.273,0.139,0.403,0.184 C491.354,567.753,491.42,567.763,491.488,567.774z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 460.7764,
    y1: 468.8105,
    x2: 460.3982,
    y2: 556.5031
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#46EEAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2CBFC7"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_24_)",
    d: "M485.282,525.74l-45.925-26.431c-0.436-0.25-0.84-0.32-1.171-0.242 c-0.162,0.02-0.447,0.181-2.013,0.847c-1.236,0.524-1.794,0.92-2.032,1.134c-0.305,0.236-0.492,0.662-0.492,1.242v40.586 c0,1.294,0.92,2.883,2.043,3.53l38.617,22.234l3.262,1.867l4.046,2.327c0.548,0.316,1.047,0.35,1.414,0.151 c0.239-0.068,0.646-0.195,1.321-0.439c1.307-0.466,2.055-1.046,2.428-1.411c0.336-0.229,0.543-0.666,0.543-1.281v-40.582 C487.323,527.976,486.407,526.386,485.282,525.74z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 453.3701,
    y1: 512.6914,
    x2: 473.0253,
    y2: 603.0291
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#46EEAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2CBFC7"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_25_)",
    d: "M482.228,573.067c0.057,0.012,0.115,0.03,0.169,0.035c0.08,0.01,0.153-0.002,0.229-0.01 c0.036,0,0.078,0,0.112-0.005c0.072-0.013,0.139-0.042,0.204-0.07c0.435-0.183,0.716-0.651,0.716-1.364v-40.582 c0-1.296-0.917-2.886-2.04-3.53l-45.925-26.43c-0.66-0.382-1.242-0.346-1.617,0.005c-0.036,0.034-0.072,0.068-0.106,0.108 c-0.036,0.045-0.065,0.097-0.096,0.149c-0.026,0.044-0.054,0.087-0.073,0.135c-0.031,0.066-0.05,0.146-0.072,0.223 c-0.012,0.045-0.027,0.086-0.037,0.134c-0.025,0.13-0.041,0.271-0.041,0.425v40.586c0,1.294,0.92,2.883,2.043,3.53 l25.104,14.448l0.008,0.01l12.645,7.282v-0.014l3.977,2.29l0.146,0.085l4.046,2.327c0.136,0.082,0.272,0.141,0.404,0.185 C482.092,573.045,482.16,573.053,482.228,573.067z"
  })))), /*#__PURE__*/React.createElement("g", null, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "#334752",
    d: "M468.658,493.915c0.058,0.012,0.115,0.029,0.168,0.033c0.08,0.01,0.153,0,0.231-0.006 c0.035-0.005,0.076,0,0.111-0.006c0.072-0.014,0.137-0.044,0.203-0.071c0.435-0.184,0.717-0.652,0.717-1.366v-40.58 c0-1.297-0.917-2.887-2.041-3.532l-45.924-26.431c-0.662-0.379-1.245-0.343-1.619,0.005c-0.035,0.036-0.072,0.071-0.104,0.111 c-0.037,0.045-0.066,0.096-0.098,0.147c-0.025,0.045-0.053,0.086-0.075,0.135c-0.028,0.069-0.05,0.145-0.068,0.222 c-0.013,0.046-0.029,0.087-0.039,0.135c-0.024,0.132-0.039,0.272-0.039,0.425v40.586c0,1.295,0.918,2.883,2.042,3.532 l25.105,14.448l0.006,0.007l12.643,7.284v-0.014l3.979,2.291l0.148,0.083l4.043,2.328c0.139,0.08,0.271,0.142,0.404,0.187 C468.524,493.893,468.59,493.899,468.658,493.915z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 437.9482,
    y1: 394.9468,
    x2: 437.57,
    y2: 482.6404
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7C6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5317F"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_26_)",
    d: "M462.452,451.878l-45.926-26.43c-0.434-0.25-0.84-0.324-1.172-0.242 c-0.16,0.02-0.445,0.18-2.012,0.847c-1.234,0.522-1.792,0.919-2.031,1.132c-0.307,0.238-0.49,0.664-0.49,1.245v40.583 c0,1.297,0.917,2.885,2.041,3.533l38.619,22.236l3.262,1.864l4.043,2.328c0.548,0.313,1.046,0.348,1.414,0.15 c0.239-0.067,0.648-0.196,1.322-0.44c1.308-0.465,2.055-1.044,2.427-1.412c0.338-0.226,0.546-0.667,0.546-1.28V455.41 C464.495,454.114,463.577,452.525,462.452,451.878z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 430.542,
    y1: 438.8306,
    x2: 450.1974,
    y2: 529.1694
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7C6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5317F"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_27_)",
    d: "M459.396,499.205c0.058,0.013,0.117,0.029,0.171,0.036c0.078,0.007,0.154-0.002,0.229-0.007 c0.036-0.005,0.076,0,0.112-0.008c0.071-0.012,0.136-0.043,0.202-0.073c0.436-0.179,0.718-0.648,0.718-1.36v-40.585 c0-1.294-0.918-2.884-2.042-3.528l-45.924-26.432c-0.659-0.38-1.243-0.343-1.617,0.007c-0.037,0.034-0.073,0.067-0.107,0.107 c-0.034,0.046-0.064,0.099-0.095,0.15c-0.027,0.046-0.054,0.085-0.073,0.135c-0.03,0.068-0.052,0.145-0.071,0.223 c-0.014,0.046-0.029,0.084-0.038,0.132c-0.025,0.132-0.039,0.273-0.039,0.428v40.583c0,1.297,0.917,2.885,2.041,3.533 l25.105,14.445l0.006,0.012l12.645,7.279v-0.011l3.977,2.289l0.148,0.086l4.043,2.328c0.139,0.077,0.273,0.141,0.404,0.185 C459.263,499.183,459.329,499.191,459.396,499.205z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 450.0215,
    y1: 188.1108,
    x2: 401.2626,
    y2: 279.5841
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#46EEAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2CBFC7"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_28_)",
    d: "M442.509,259.341l-72.516-41.735c-0.688-0.395-1.328-0.507-1.854-0.382 c-0.253,0.029-0.703,0.287-3.176,1.335c-1.951,0.83-2.829,1.453-3.209,1.791c-0.482,0.375-0.775,1.046-0.775,1.964v64.083 c0,2.045,1.451,4.556,3.225,5.577l48.603,27.971l11.046,31.031l6.481-3.307V330.03l6.388,3.677 c0.865,0.499,1.652,0.55,2.232,0.238c0.379-0.106,1.021-0.307,2.088-0.695c2.064-0.732,3.242-1.648,3.831-2.229 c0.532-0.356,0.861-1.052,0.861-2.022v-64.082C445.734,262.869,444.284,260.359,442.509,259.341z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.1382,
    y1: 247.9121,
    x2: 390.5281,
    y2: 385.3788
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#46EEAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2CBFC7"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_29_)",
    d: "M436.722,262.183l-72.518-41.734c-1.773-1.021-3.225-0.183-3.225,1.865v64.083 c0,2.045,1.451,4.556,3.225,5.577l39.643,22.813l19.975,36.291v-24.795l12.9,7.424c1.773,1.02,3.225,0.181,3.225-1.865v-64.084 C439.946,265.713,438.495,263.2,436.722,262.183z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M389.134,280.887l-7.618-9.578c-0.261-0.312-0.441-0.587-0.549-0.827 c-0.106-0.239-0.158-0.484-0.158-0.729v-0.451c0-0.246,0.052-0.433,0.158-0.563c0.107-0.13,0.288-0.223,0.549-0.28l7.618-1.634 c0.032,0,0.113-0.006,0.242-0.015c0.131-0.008,0.246,0.013,0.344,0.064c0.146,0.077,0.269,0.19,0.365,0.337 c0.099,0.147,0.146,0.301,0.146,0.457v1.071c0,0.19-0.046,0.323-0.134,0.396c-0.091,0.077-0.232,0.132-0.427,0.167l-6.594,1.396 l6.594,8.269c0.209,0.268,0.358,0.482,0.439,0.645c0.08,0.164,0.121,0.334,0.121,0.507v1.07c0,0.173-0.048,0.284-0.146,0.327 c-0.097,0.048-0.22,0.033-0.365-0.042C389.605,281.417,389.409,281.22,389.134,280.887z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M392.673,286.891c-0.098-0.154-0.146-0.299-0.146-0.438c0-0.072,0.024-0.162,0.072-0.275l8.351-16.899 c0.147-0.211,0.359-0.244,0.635-0.098l0.903,0.486c0.131,0.069,0.244,0.181,0.342,0.335c0.098,0.157,0.148,0.303,0.148,0.439 c0,0.067-0.025,0.158-0.074,0.269l-8.375,16.836c-0.033,0.088-0.103,0.152-0.207,0.194c-0.105,0.041-0.248,0.016-0.427-0.074 l-0.881-0.446C392.884,287.153,392.77,287.045,392.673,286.891z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M405.393,289.352c-0.097-0.154-0.146-0.307-0.146-0.46v-1.052c0-0.169,0.041-0.294,0.121-0.373 c0.081-0.076,0.228-0.136,0.44-0.182l6.592-1.295l-6.592-8.173c-0.197-0.239-0.339-0.443-0.429-0.61 c-0.088-0.167-0.133-0.343-0.133-0.532v-1.049c0-0.156,0.045-0.256,0.133-0.302c0.09-0.045,0.21-0.029,0.355,0.049 c0.098,0.052,0.215,0.151,0.354,0.302s0.225,0.243,0.256,0.277l7.617,9.481c0.26,0.324,0.443,0.601,0.549,0.833 c0.107,0.232,0.158,0.468,0.158,0.702v0.43c0,0.237-0.051,0.416-0.158,0.538c-0.105,0.123-0.289,0.201-0.549,0.235l-7.617,1.539 c-0.258,0.054-0.463,0.043-0.609-0.03C405.604,289.61,405.489,289.502,405.393,289.352z"
  })))), /*#__PURE__*/React.createElement("g", null, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#334752",
    d: "M355.729,619.737c-2.5-1.438-6.557-1.381-9.012,0.132l-19.059,11.724 c-2.456,1.512-2.422,3.927,0.078,5.365l62.293,35.849c2.499,1.438,6.555,1.38,9.012-0.132l19.057-11.724 c2.459-1.513,2.422-3.927-0.077-5.364L355.729,619.737z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.5381,
    y1: 483.4053,
    x2: 378.513,
    y2: 474.3478
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8A980"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDF75"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_30_)",
    d: "M340.225,478.67l23.811-1.048c0,0,0.697-3.487,3.489-3.227 c2.791,0.265,10.904-0.089,10.904-0.089s4.885-0.782-2.441,2.446c-7.327,3.224-8.551,4.186-10.817,3.489 c-1.657,0.085-21.717,6.452-23.461,5.579c-1.745-0.872-1.396-3.141-1.396-3.141L340.225,478.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 338.0908,
    y1: 463.6035,
    x2: 359.333,
    y2: 463.6035
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFF57A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#54D169"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_31_)",
    d: "M359.224,441.292h-3.867c0,0-6.962,2.102-10.936,14.252 c-3.976,12.148-5.964,17.895-6.074,20.545c-0.111,2.648-1.105,7.843,1.768,9.279c2.872,1.436,5.082-0.222,6.518-1.879 c1.438-1.656,0.773-3.426,2.098-6.85c1.326-3.422,2.098-8.504,4.641-10.271c2.541-1.768,5.963-6.405,5.963-6.405 L359.224,441.292z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 345.7803,
    y1: 634.9043,
    x2: 365.0024,
    y2: 634.9043
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#334752"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6A6D89"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_32_)",
    d: "M347.194,631.049l-1.044,0.771c0,0-0.282,2.489-0.191,3.945 c0.095,1.455-0.569,3.001,0.191,3.256c0.759,0.26,2.753,0.86,4.175,0.26c1.426-0.601,1.236-2.144,2.09-2.061 c0.854,0.087,5.889-1.198,9.307-2.911c3.415-1.716,4.463-4.203,1.707-4.031c-2.755,0.173-8.827,1.198-11.202,1.63 c-0.511,0.106-0.599-0.265-0.599-0.265l-1.016-0.159l-1.266-0.179L347.194,631.049z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#131316",
    cx: 348.903,
    cy: 631.82,
    rx: 2.753,
    ry: 1.373
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 271.5605,
    y1: 606.8418,
    x2: 412.7293,
    y2: 550.5069
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#15EDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#029CF5"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_33_)",
    d: "M356.239,516.525c-6,1.151-4.33,4.451-4.33,7.536c0,3.086-1.781,19.463-3.977,40.827 c-2.023,19.664-1.008,28.246-1.246,43.318c-0.189,11.987-1.05,18.177-1.395,20.217c-0.086,0.253-0.146,0.515-0.146,0.789 c0,1.703,1.754,3.086,3.914,3.086c2.166,0,3.917-1.383,3.917-3.086c0,0,2.296-30.063,2.7-33.261 c2.017-15.932,7.388-34.98,9.406-42.101c2.018-7.121,10.681-31.866,10.681-31.866S369.534,513.973,356.239,516.525z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 379.542,
    y1: 451.5693,
    x2: 371.3684,
    y2: 434.9994
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8A980"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDF75"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_34_)",
    d: "M366.619,449.456c0.462-0.871,3.65-7.794,4.162-12.346c0.511-4.555,0.274-7.08,0.579-7.184 c0.307-0.102,3.123-0.768,3.123-0.768l5.371,2.866l2.457,1.075c0,0,1.516,3.883-0.51,5.781 c-4.813,4.299-3.789,14.736-0.564,14.482c0.298-0.026,0,3.426-3.172,2.301c-3.174-1.124-7.268-3.121-7.829-3.583 C369.673,451.622,366.619,449.456,366.619,449.456z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.4971,
    y1: 435.3838,
    x2: 394.3568,
    y2: 420.14
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8A980"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDF75"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_35_)",
    d: "M384.304,431.685c0.584-0.234,1.078-0.684,1.078-1.262c0-0.751-2.422-5.057-3.558-6.014 c-0.098-0.818-0.218-1.823-0.331-2.684c-0.238-1.809-0.685-2.936-2.149-2.936c-1.466,0-4.707,0.749-4.707,0.749 s-3.788,2.118-3.788,2.22c0,0.101-4.707,10.608-4.707,10.949s6.241,8.121,16.135,8.153c1.244,0,2.252-1.01,2.252-2.252 c0-0.271-0.057-0.532-0.146-0.775c-0.092-0.546-0.194-1.286-0.194-1.884c0-1.094,0.615-1.57,0.341-2.115 c-0.273-0.544-0.682-0.89-0.477-1.435C384.114,432.229,384.206,431.965,384.304,431.685z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.6616,
    y1: 655.9609,
    x2: 391.2528,
    y2: 648.5023
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#334752"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6A6D89"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_36_)",
    d: "M381.771,647.458l-1.304,1.071c0,0-0.354,3.44-0.236,5.456c0.116,2.021-0.714,4.156,0.236,4.514 c0.948,0.355,3.441,1.187,5.222,0.355c1.779-0.829,1.543-2.967,2.609-2.848c1.069,0.117,7.36-1.66,11.633-4.036 c4.271-2.374,5.579-5.817,2.135-5.579c-3.439,0.238-11.036,1.66-14.002,2.254c-0.639,0.151-0.751-0.359-0.751-0.359 l-1.269-0.225l-1.579-0.245L381.771,647.458z"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#131316",
    cx: 383.909,
    cy: 648.529,
    rx: 3.442,
    ry: 1.898
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 452.0342,
    y1: 671.3477,
    x2: 335.384,
    y2: 517.9126
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#15EDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#029CF5"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_37_)",
    d: "M390.486,520.272l-13.845,2.246c-0.884-5.754-4.766-10.089-9.422-10.089 c-5.309,0-9.614,5.635-9.614,12.581c0,2.442,0.542,4.713,1.461,6.642c2.532,6.756,12.851,14.929,13.968,25.403 c1.188,11.155,4.63,15.903,5.102,22.429c0.475,6.528,0.951,36.555,1.542,46.168c0.593,9.614,0.924,21.034,0.924,21.034 c0,1.524,1.435,2.756,3.202,2.756c1.77,0,3.201-1.231,3.201-2.756c0,0,3.475-48.807,3.713-59.725 c0.234-10.918,0.117-11.629,0.237-25.278C391.091,545.823,390.486,520.272,390.486,520.272z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.4023,
    y1: 430.2129,
    x2: 381.5998,
    y2: 523.0031
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFF57A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#54D169"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_38_)",
    d: "M390.595,486.471c2.432-9.94,3.867-13.807,3.867-13.807l-1.436-18.337 c0,0-5.719-3.369-11.931-4.528c-4.749-0.886-7.208-1.324-11.71-3.646c-1.119-0.578-3.287-3.645-8.672-5.136 c0,0-5.219-1.575-7.344,2.044c-2.783,4.736-1.324,10.051,0.109,21.979c1.436,11.931,1.549,25.737,0,35.901 c-0.897,5.905-2.389,12.923-1.643,17.119c0.004,0.052-0.006,0.09,0,0.142c0.036,0.395,0.165,0.779,0.34,1.159 c0.358,0.98,0.916,1.711,1.736,2.098c3.217,2.605,9.862,4.422,17.819,4.422c7.526,0,13.763-1.44,17.116-3.701 c1.5-0.519,3.14-2.269,3.074-7.319C391.811,506.135,388.164,496.416,390.595,486.471z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#334752",
    d: "M380.417,419.646c0.685-3.619-0.093-11.009-0.093-11.009c0-0.581-0.501-1.047-1.126-1.047 c-9.069-0.324-18.213,11.138-19.992,13.489c-0.965,1.123-1.563,2.52-1.563,4.06c0,0.47,0.057,0.928,0.158,1.371 c-0.01,0.043-0.023,0.08-0.033,0.124c0.625,4.431,7.611,11.668,7.611,11.668l0.059-0.005c0.752,0.748,1.813,1.222,2.999,1.222 c2.034,0,3.718-1.38,4.048-3.193c0.007-0.019,0.016-0.035,0.023-0.058c0.249-1.062,0.796-3.515,0.547-7.979 c-0.084-1.461,4.484-2.856,4.602-2.879l0.058-0.038c0.86-0.298,1.524-0.952,1.802-1.771c0.005-0.008,0.007-0.011,0.01-0.015 c0.004-0.02,0.008-0.029,0.012-0.048c0.044-0.151,0.076-0.304,0.096-0.456C379.823,422.15,379.823,421.963,380.417,419.646z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.4717,
    y1: 491.8447,
    x2: 461.7961,
    y2: 483.6703
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8A980"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDF75"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_39_)",
    d: "M407.607,486.804l30.156-1.326c0,0,0.884-4.417,4.417-4.087 c3.535,0.331,13.81-0.109,13.81-0.109s6.187-0.995-3.092,3.093s-10.829,5.303-13.698,4.421 c-2.1,0.107-27.506,8.171-29.715,7.067c-2.209-1.107-1.768-3.979-1.768-3.979L407.607,486.804z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 411.9868,
    y1: 498.9116,
    x2: 384.4588,
    y2: 452.8648
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFF57A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#54D169"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_40_)",
    d: "M411.337,485.227c-0.305-1.549-2.902-3.696-8.371-16.373c-3.225-7.478-5.793-11.02-7.364-12.68 c-1.479-1.73-3.739-2.84-6.275-2.84c-4.455,0-8.064,3.411-8.064,7.621c0,0.528,0.058,1.041,0.166,1.537 c-0.129,5.569,16.487,21.692,18.97,24.672c2.486,2.982,3.254,5.974,6.463,8.559c3.508,2.734,4.477,1.186,3.785-2.042 C410.001,490.688,412.081,489.036,411.337,485.227z"
  })))), /*#__PURE__*/React.createElement("g", null, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#334752",
    d: "M544.389,791.159c2.821-1.623,7.395-1.556,10.165,0.149l21.492,13.224 c2.771,1.703,2.73,4.428-0.088,6.049l-70.251,40.43c-2.819,1.623-7.393,1.555-10.165-0.148l-21.491-13.223 c-2.771-1.706-2.729-4.43,0.089-6.049L544.389,791.159z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 1605.7646,
    y1: 824.3877,
    x2: 1653.1063,
    y2: 814.1721,
    gradientTransform: "matrix(-0.9118 -0.4106 -0.4106 0.9118 2350.1846 551.7522)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8A980"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDF75"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_41_)",
    d: "M545.957,637.522l-24-12.102c0,0,0.9-3.91-2.094-4.938c-2.991-1.019-11.17-5.136-11.17-5.136 s-4.661-3.069,1.378,3.642c6.041,6.714,6.853,8.265,9.51,8.597c1.662,0.857,19.342,16.693,21.539,16.605 c2.199-0.089,2.891-2.582,2.891-2.582L545.957,637.522z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 1607.5166,
    y1: 802.0537,
    x2: 1631.4717,
    y2: 802.0537,
    gradientTransform: "matrix(-0.9118 -0.4106 -0.4106 0.9118 2350.1846 551.7522)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDF2F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3D0D8"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_42_)",
    d: "M543.729,590.29l3.975,1.789c0,0,6.186,5.384,4.648,19.72 c-1.537,14.337-2.153,21.162-3.269,23.94c-1.114,2.775-2.494,8.577-6.114,8.725c-3.617,0.145-5.123-2.581-5.831-4.951 c-0.71-2.367,0.79-3.879,1.015-8.013c0.222-4.137,1.781-9.722-0.016-12.713c-1.796-2.993-3.166-9.349-3.166-9.349L543.729,590.29 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 3727.5332,
    y1: 808.2637,
    x2: 3749.2109,
    y2: 808.2637,
    gradientTransform: "matrix(-1 0 0 1 4283.1426 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#334752"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6A6D89"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_43_)",
    d: "M554.016,803.917l1.178,0.871c0,0,0.319,2.807,0.215,4.446c-0.107,1.646,0.642,3.386-0.215,3.677 c-0.856,0.289-3.103,0.967-4.71,0.289c-1.605-0.675-1.394-2.418-2.355-2.32c-0.966,0.098-6.641-1.354-10.494-3.285 c-3.854-1.936-5.035-4.742-1.928-4.548c3.106,0.194,9.956,1.354,12.635,1.839c0.575,0.12,0.676-0.297,0.676-0.297l1.146-0.18 l1.424-0.204L554.016,803.917z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#131316",
    d: "M548.983,804.788c0,0.854,1.389,1.545,3.107,1.545c1.713,0,3.103-0.691,3.103-1.545 c0-0.854-1.39-1.547-3.103-1.547C550.372,803.241,548.983,803.934,548.983,804.788z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 3643.8271,
    y1: 776.6182,
    x2: 3803.0361,
    y2: 713.0841,
    gradientTransform: "matrix(-1 0 0 1 4283.1426 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE600"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC400"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_44_)",
    d: "M543.813,674.761c6.768,1.299,4.885,5.02,4.885,8.5c0,3.481,2.007,21.949,4.484,46.041 c2.281,22.178,1.137,31.855,1.404,48.854c0.215,13.518,1.186,20.501,1.574,22.801c0.098,0.286,0.165,0.581,0.165,0.891 c0,1.922-1.978,3.478-4.415,3.478c-2.441,0-4.417-1.556-4.417-3.478c0,0-2.59-33.906-3.044-37.512 c-2.276-17.968-8.334-39.451-10.611-47.48c-2.271-8.032-12.043-35.938-12.043-35.938S528.821,671.884,543.813,674.761z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 3765.6074,
    y1: 601.5049,
    x2: 3756.3896,
    y2: 582.8181,
    gradientTransform: "matrix(-1 0 0 1 4283.1426 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8A980"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDF75"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_45_)",
    d: "M532.109,599.122c-0.522-0.983-4.118-8.79-4.693-13.924c-0.578-5.139-0.312-7.984-0.656-8.101 c-0.345-0.115-3.518-0.866-3.518-0.866l-6.06,3.234l-2.771,1.21c0,0-1.707,4.382,0.577,6.52c5.426,4.85,4.269,16.62,0.634,16.333 c-0.335-0.027,0,3.865,3.58,2.595c3.577-1.267,8.193-3.52,8.828-4.037C528.665,601.566,532.109,599.122,532.109,599.122z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 3755.4072,
    y1: 583.252,
    x2: 3782.3164,
    y2: 566.0599,
    gradientTransform: "matrix(-1 0 0 1 4283.1426 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8A980"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDF75"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_46_)",
    d: "M512.165,579.079c-0.658-0.263-1.215-0.772-1.215-1.422c0-0.85,2.729-5.703,4.012-6.781 c0.109-0.923,0.245-2.058,0.371-3.029c0.27-2.039,0.771-3.309,2.425-3.309s5.31,0.844,5.31,0.844s4.271,2.388,4.271,2.502 c0,0.117,5.309,11.965,5.309,12.351c0,0.383-7.039,9.157-18.197,9.194c-1.402,0-2.536-1.138-2.536-2.54 c0-0.308,0.061-0.598,0.163-0.872c0.104-0.619,0.22-1.453,0.22-2.126c0-1.233-0.695-1.772-0.388-2.388 c0.309-0.613,0.771-1.001,0.54-1.616C512.379,579.694,512.274,579.396,512.165,579.079z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 3780.4053,
    y1: 832.0107,
    x2: 3778.8169,
    y2: 823.6013,
    gradientTransform: "matrix(-1 0 0 1 4283.1426 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#334752"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6A6D89"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_47_)",
    d: "M515.02,822.425l1.473,1.205c0,0,0.4,3.881,0.267,6.158c-0.133,2.273,0.803,4.683-0.267,5.085 c-1.071,0.401-3.882,1.339-5.89,0.401s-1.738-3.345-2.943-3.213c-1.205,0.134-8.3-1.872-13.117-4.549 c-4.82-2.678-6.292-6.561-2.41-6.291c3.881,0.266,12.448,1.872,15.793,2.541c0.72,0.169,0.847-0.41,0.847-0.41l1.429-0.249 l1.784-0.275L515.02,822.425z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#131316",
    d: "M508.728,823.63c0,1.182,1.74,2.142,3.883,2.142s3.882-0.96,3.882-2.142c0-1.18-1.739-2.143-3.882-2.143 S508.728,822.45,508.728,823.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 504.6406,
    y1: 747.4023,
    x2: 542.2734,
    y2: 747.4023
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE600"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC400"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_48_)",
    d: "M505.193,678.988l15.612,2.53c0.998-6.488,5.375-11.375,10.627-11.375 c5.986,0,10.841,6.352,10.841,14.188c0,2.752-0.61,5.313-1.647,7.488c-2.855,7.619-14.492,16.838-15.754,28.647 c-1.338,12.584-5.219,17.936-5.751,25.297c-0.536,7.363-1.073,41.227-1.74,52.068c-0.667,10.84-1.042,23.723-1.042,23.723 c0,1.714-1.616,3.105-3.61,3.105c-1.995,0-3.611-1.392-3.611-3.105c0,0-3.918-55.043-4.185-67.356 c-0.267-12.315-0.134-13.118-0.27-28.511C504.509,707.803,505.193,678.988,505.193,678.988z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 502.5332,
    y1: 607.6455,
    x2: 582.6359,
    y2: 703.2308
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDF2F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3D0D8"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_49_)",
    d: "M505.069,640.87c-2.74-11.212-4.359-15.574-4.359-15.574l1.619-20.682 c0,0,6.447-3.798,13.452-5.105c5.356-1.001,8.132-1.496,13.208-4.112c1.261-0.65,3.707-4.109,9.779-5.791 c0,0,5.887-1.776,8.281,2.303c3.142,5.345,1.496,11.339-0.122,24.792c-1.62,13.453-1.745,29.025,0,40.487 c1.013,6.66,2.692,14.572,1.853,19.308c-0.004,0.055,0.007,0.1,0,0.157c-0.041,0.446-0.188,0.879-0.385,1.308 c-0.404,1.106-1.032,1.93-1.957,2.368c-3.629,2.935-11.121,4.983-20.096,4.983c-8.487,0-15.521-1.627-19.305-4.171 c-1.688-0.587-3.539-2.561-3.465-8.257C503.698,663.042,507.81,652.081,505.069,640.87z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A3C20",
    d: "M516.55,565.504c-0.775-4.081,0.104-12.419,0.104-12.419c0-0.652,0.564-1.182,1.268-1.182 c10.232-0.359,20.541,12.566,22.548,15.215c1.087,1.268,1.764,2.846,1.764,4.579c0,0.529-0.066,1.047-0.181,1.548 c0.012,0.051,0.027,0.09,0.037,0.14c-0.703,4.995-8.583,13.163-8.583,13.163l-0.066-0.009c-0.849,0.845-2.044,1.378-3.382,1.378 c-2.293,0-4.192-1.559-4.564-3.6c-0.008-0.023-0.02-0.043-0.026-0.068c-0.28-1.196-0.897-3.966-0.619-8.998 c0.099-1.646-5.055-3.223-5.187-3.246l-0.065-0.041c-0.97-0.338-1.718-1.075-2.03-2c-0.007-0.007-0.01-0.011-0.016-0.016 c-0.002-0.021-0.006-0.035-0.011-0.057c-0.049-0.168-0.085-0.339-0.107-0.514C517.218,568.327,517.218,568.116,516.55,565.504z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 7325.0225,
    y1: -4964.2676,
    x2: 7405.0063,
    y2: -4975.4775,
    gradientTransform: "matrix(-0.1406 0.9901 0.9901 0.1406 6452.4229 -5912.5415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8A980"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDF75"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_50_)",
    d: "M499.808,646.737l-8.286,45.629c0,0-5.077,0.285-5.267,4.282 c-0.19,4.003-2.315,15.404-2.315,15.404s-2.091,6.751,3.945-2.964c6.034-9.713,7.638-11.248,7.106-14.592 c0.454-2.325,12.813-28.529,12.305-31.27c-0.42-2.27,4.082-11.359,1.81-14.976c-0.308-0.491-4.542,3.344-4.542,3.344 L499.808,646.737z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 491.5488,
    y1: 605.1387,
    x2: 530.5911,
    y2: 668.4135
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDF2F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3D0D8"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_51_)",
    d: "M499.126,649.322c-1.217-1.295,0.522-5.272-1.953-20.643c-1.457-9.068-1.16-13.993-0.669-16.522 c0.358-2.543,1.838-4.968,4.25-6.505c4.238-2.694,9.739-1.634,12.287,2.37c0.318,0.5,0.576,1.025,0.773,1.566 c3.493,5.218-2.554,30.617-3.109,34.956c-0.559,4.343,0.231,8.059-3.364,7.933C504.614,652.384,500.989,651.315,499.126,649.322z "
  }))), /*#__PURE__*/React.createElement("g", null, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#334752",
    d: "M385.046,738.275c-1.929-1.218-5.135-1.303-7.123-0.188l-54.508,30.528 c-1.987,1.111-2.038,3.021-0.111,4.239l68.044,42.966c1.93,1.221,5.137,1.305,7.125,0.188l54.507-30.525 c1.989-1.115,2.04-3.023,0.11-4.24L385.046,738.275z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 394.354,
    y1: 727.5596,
    x2: 387.5379,
    y2: 799.7485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDF40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF8359"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_52_)",
    d: "M449.559,779.718l0.208-5.63c0.184-0.79-0.218-1.63-1.221-2.263l-61.004-38.523 c-1.729-1.092-4.604-1.167-6.39-0.167l-48.866,27.369c-0.949,0.531-1.404,1.268-1.357,2.003l-0.236,5.75 c-0.018,0.113-0.022,0.227-0.013,0.34l-0.005,0.057h0.006c0.06,0.624,0.472,1.245,1.258,1.738l61.004,38.521 c1.729,1.091,4.604,1.169,6.387,0.17l48.867-27.368c0.948-0.532,1.4-1.264,1.359-1.997 C449.559,779.718,449.559,779.718,449.559,779.718z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.3652,
    y1: 762.0781,
    x2: 382.0704,
    y2: 817.8474
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDF40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF8359"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_53_)",
    d: "M387.542,733.302c-1.729-1.092-4.604-1.167-6.39-0.167l-48.866,27.369 c-1.783,0.997-1.828,2.708-0.098,3.802l61.004,38.521c1.729,1.091,4.604,1.169,6.388,0.168l48.866-27.369 c1.784-0.999,1.83-2.708,0.1-3.8L387.542,733.302z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.0649,
    y1: 728.8984,
    x2: 400.2765,
    y2: 803.567
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFF57A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#54D169"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_54_)",
    d: "M461.429,770.405l-0.126-5.633c0.136-0.8-0.316-1.616-1.354-2.189l-63.183-34.839 c-1.789-0.987-4.663-0.891-6.385,0.211l-47.156,30.218c-0.921,0.59-1.328,1.35-1.24,2.082l0.105,5.754 c-0.01,0.112-0.008,0.226,0.007,0.338l0.001,0.059h0.004c0.096,0.618,0.549,1.214,1.357,1.66l63.182,34.839 c1.791,0.987,4.666,0.894,6.387-0.212l47.158-30.217c0.914-0.585,1.32-1.344,1.238-2.07 C461.427,770.405,461.429,770.405,461.429,770.405z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.0449,
    y1: 727.9189,
    x2: 370.0615,
    y2: 821.2773
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFF57A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#54D169"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_55_)",
    d: "M396.767,727.744c-1.789-0.987-4.663-0.891-6.385,0.211l-47.156,30.218 c-1.724,1.104-1.668,2.813,0.123,3.803l63.184,34.836c1.789,0.988,4.663,0.891,6.385-0.21l47.158-30.217 c1.722-1.104,1.664-2.813-0.126-3.802L396.767,727.744z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 406.022,
    y1: 686.9414,
    x2: 394.0422,
    y2: 765.8436
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#15EDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#029CF5"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_56_)",
    d: "M455.751,758.277l-0.024-5.634c0.151-0.799-0.285-1.622-1.313-2.214l-62.535-35.986 c-1.772-1.022-4.646-0.979-6.388,0.093l-47.704,29.348c-0.928,0.574-1.351,1.325-1.275,2.061v5.752 c-0.013,0.114-0.013,0.226,0,0.342v0.055l0.005-0.002c0.085,0.623,0.525,1.229,1.327,1.689l62.532,35.988 c1.774,1.021,4.647,0.977,6.39-0.094l47.702-29.351c0.928-0.569,1.348-1.315,1.279-2.047H455.751z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.7119,
    y1: 713.3105,
    x2: 372.3602,
    y2: 816.5834
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#15EDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#029CF5"
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_57_)",
    d: "M391.879,714.443c-1.772-1.022-4.646-0.979-6.388,0.093l-47.704,29.348 c-1.739,1.072-1.716,2.784,0.057,3.804l62.532,35.987c1.774,1.02,4.647,0.979,6.39-0.095l47.702-29.347 c1.743-1.071,1.719-2.783-0.054-3.804L391.879,714.443z"
  })))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A6D89",
    d: "M400.471,769.329l-3.407-27.884l-17.35,2.785l4.337-12.391l-30.8,2.528l-15.464,9.516 c-1.739,1.072-1.716,2.784,0.057,3.804l62.532,35.987c1.774,1.02,4.647,0.979,6.39-0.095l9.431-5.804l-0.854-11.236 L400.471,769.329z"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFE600",
    cx: 414.724,
    cy: 752.287,
    rx: 14.445,
    ry: 10.987
  })))), /*#__PURE__*/React.createElement("g", null, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#334752",
    d: "M253.844,633.486c1.642-1.037,4.373-1.108,6.067-0.158l46.411,25.992 c1.692,0.948,1.735,2.575,0.093,3.612l-57.938,36.585c-1.643,1.036-4.374,1.104-6.068,0.159l-46.41-25.994 c-1.694-0.946-1.738-2.572-0.094-3.609L253.844,633.486z"
  })))), /*#__PURE__*/React.createElement("g", null, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#C3D0D8",
    d: "M198.913,668.775l-0.178-4.792c-0.156-0.675,0.187-1.391,1.039-1.931l51.944-32.8 c1.472-0.93,3.92-0.995,5.439-0.143l41.61,23.304c0.808,0.452,1.194,1.079,1.156,1.706l0.202,4.895 c0.014,0.096,0.017,0.195,0.012,0.291l0.002,0.045h-0.005c-0.051,0.534-0.403,1.062-1.07,1.482l-51.945,32.802 c-1.471,0.932-3.918,0.995-5.437,0.143l-41.61-23.303c-0.807-0.453-1.191-1.076-1.157-1.699H198.913z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 3305.8281,
    y1: 653.7539,
    x2: 3297.9141,
    y2: 701.2388,
    gradientTransform: "matrix(-1 0 0 1 3554.291 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDF2F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E4EB"
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_58_)",
    d: "M251.719,629.253c1.472-0.93,3.92-0.995,5.439-0.143l41.61,23.304 c1.518,0.851,1.557,2.307,0.085,3.235l-51.945,32.799c-1.472,0.932-3.92,0.996-5.439,0.145L199.86,665.29 c-1.519-0.851-1.558-2.306-0.085-3.237L251.719,629.253z"
  }))))), /*#__PURE__*/React.createElement("g", null, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#C3D0D8",
    d: "M194.913,658.396l0.02-4.797c-0.131-0.679,0.241-1.381,1.118-1.886l53.245-30.644 c1.509-0.868,3.957-0.833,5.441,0.08l40.618,24.992c0.791,0.484,1.149,1.127,1.085,1.752v4.9c0.01,0.096,0.01,0.192,0,0.286 v0.05h-0.004c-0.071,0.528-0.446,1.043-1.129,1.436l-53.246,30.645c-1.51,0.867-3.957,0.833-5.439-0.08l-40.618-24.99 c-0.79-0.484-1.146-1.125-1.089-1.744H194.913z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 3310.9629,
    y1: 636.9795,
    x2: 3302.5771,
    y2: 685.3881,
    gradientTransform: "matrix(-1 0 0 1 3554.291 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDF2F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E4EB"
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_59_)",
    d: "M249.295,621.069c1.509-0.868,3.957-0.833,5.441,0.08l40.618,24.992 c1.482,0.91,1.46,2.367-0.048,3.237l-53.246,30.644c-1.51,0.868-3.957,0.83-5.439-0.082l-40.618-24.99 c-1.483-0.91-1.462-2.367,0.047-3.237L249.295,621.069z"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#334752",
    d: "M253.718,649.448c-0.149,0.093-0.228,0.198-0.243,0.317c-0.009,0.12,0.048,0.225,0.17,0.311 l1.264,0.901c0.121,0.088,0.268,0.132,0.441,0.127c0.183,0,0.341-0.045,0.49-0.137l1.533-0.93 c0.149-0.09,0.231-0.189,0.243-0.309c0.02-0.117-0.031-0.218-0.153-0.303l-1.265-0.902c-0.121-0.088-0.273-0.133-0.459-0.135 c-0.177-0.002-0.343,0.04-0.491,0.13L253.718,649.448z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#334752",
    d: "M246.278,638.002c-0.148,0.09-0.234,0.188-0.25,0.295c-0.016,0.105,0.042,0.204,0.164,0.291 l0.62,0.443c0.123,0.087,0.261,0.129,0.424,0.127c0.164,0,0.313-0.04,0.444-0.119l0.112-0.065 c0.721-0.43,1.404-0.643,2.04-0.648c0.633-0.01,1.287,0.161,1.966,0.498c0.675,0.337,1.563,0.895,2.649,1.672 c1.423,1.018,2.947,1.378,4.556,1.08c-0.583,1.029-0.164,2.055,1.265,3.077c1.086,0.775,1.858,1.403,2.322,1.881 c0.461,0.477,0.664,0.919,0.597,1.332c-0.069,0.409-0.455,0.837-1.153,1.278l-0.112,0.067 c-0.122,0.086-0.19,0.185-0.205,0.294c-0.017,0.105,0.033,0.196,0.142,0.273l0.642,0.459c0.122,0.088,0.261,0.13,0.423,0.129 c0.165-0.001,0.325-0.048,0.472-0.138l0.11-0.065c1.124-0.682,1.799-1.361,2.025-2.029c0.224-0.668,0.085-1.354-0.428-2.053 c-0.507-0.698-1.373-1.476-2.58-2.339c-0.625-0.446-1.006-0.852-1.164-1.216c-0.153-0.365-0.134-0.761,0.062-1.188 l0.084-0.148c0.105-0.195,0.149-0.355,0.129-0.481c-0.025-0.119-0.113-0.242-0.271-0.35l-0.33-0.237 c-0.16-0.114-0.332-0.185-0.516-0.209c-0.187-0.025-0.429-0.007-0.732,0.048l-0.27,0.044 c-0.666,0.096-1.259,0.076-1.786-0.059c-0.525-0.129-1.102-0.414-1.723-0.857c-1.208-0.863-2.316-1.493-3.321-1.895 c-1.004-0.395-2.022-0.549-3.051-0.443c-1.023,0.098-2.109,0.492-3.247,1.184L246.278,638.002z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#334752",
    d: "M248.166,652.823c-0.146,0.087-0.23,0.195-0.242,0.312c-0.008,0.121,0.048,0.223,0.17,0.312 l1.265,0.904c0.122,0.083,0.271,0.129,0.442,0.126c0.177,0.002,0.343-0.047,0.491-0.137l1.533-0.934 c0.142-0.084,0.229-0.188,0.243-0.306c0.016-0.112-0.038-0.215-0.158-0.301l-1.263-0.902 c-0.122-0.089-0.275-0.134-0.456-0.139c-0.178-0.002-0.348,0.047-0.491,0.133L248.166,652.823z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#334752",
    d: "M227.357,649.488c-1.124,0.685-1.809,1.364-2.043,2.039c-0.228,0.673-0.086,1.358,0.43,2.048 c0.518,0.698,1.382,1.478,2.59,2.339c0.621,0.443,1.007,0.852,1.153,1.222c0.148,0.37,0.129,0.768-0.073,1.193l-0.079,0.146 c-0.109,0.194-0.153,0.358-0.133,0.478c0.019,0.124,0.104,0.241,0.252,0.347l0.348,0.248c0.144,0.103,0.311,0.168,0.5,0.19 c0.186,0.026,0.44,0.013,0.755-0.035l0.246-0.05c0.676-0.091,1.277-0.072,1.815,0.057c0.534,0.128,1.111,0.416,1.733,0.86 c1.208,0.863,2.311,1.488,3.314,1.879c0.999,0.393,2.018,0.542,3.049,0.451c1.031-0.097,2.111-0.483,3.239-1.168l0.131-0.08 c0.131-0.081,0.209-0.18,0.23-0.289c0.02-0.11-0.023-0.211-0.144-0.298l-0.644-0.46c-0.109-0.077-0.251-0.109-0.421-0.105 c-0.169,0.006-0.329,0.045-0.469,0.119l-0.111,0.066c-0.725,0.422-1.397,0.638-2.025,0.65 c-0.631,0.01-1.288-0.154-1.972-0.496c-0.685-0.344-1.573-0.9-2.659-1.676c-1.415-1.014-2.928-1.366-4.533-1.07 c0.578-1.03,0.154-2.059-1.272-3.076c-1.073-0.768-1.845-1.396-2.311-1.876c-0.466-0.479-0.667-0.929-0.601-1.34 c0.067-0.411,0.449-0.835,1.147-1.278l0.094-0.077c0.131-0.08,0.208-0.18,0.229-0.29c0.021-0.11-0.021-0.209-0.143-0.297 l-0.62-0.443c-0.124-0.088-0.275-0.127-0.443-0.122c-0.17,0.004-0.319,0.049-0.451,0.13L227.357,649.488z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#334752",
    d: "M242.617,656.19c-0.152,0.095-0.231,0.198-0.242,0.313c-0.009,0.121,0.044,0.229,0.165,0.316 l1.264,0.904c0.123,0.085,0.276,0.123,0.447,0.123c0.178,0,0.339-0.045,0.491-0.137l1.528-0.93 c0.146-0.09,0.23-0.191,0.247-0.312c0.017-0.111-0.034-0.211-0.156-0.301l-1.263-0.899c-0.124-0.09-0.275-0.133-0.456-0.14 c-0.183,0-0.348,0.045-0.496,0.136L242.617,656.19z"
  })))))), /*#__PURE__*/React.createElement("g", null, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#334752",
    d: "M156.594,730.667c-0.939-0.595-2.499-0.637-3.469-0.093l-26.54,14.864 c-0.969,0.544-0.994,1.474-0.053,2.063l33.131,20.924c0.939,0.594,2.5,0.632,3.47,0.092l26.54-14.866 c0.969-0.542,0.993-1.471,0.052-2.062L156.594,730.667z"
  })))), /*#__PURE__*/React.createElement("g", null, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#C3D0D8",
    d: "M188.006,750.847l0.102-2.743c0.089-0.384-0.107-0.793-0.595-1.102l-29.705-18.758 c-0.842-0.53-2.241-0.569-3.111-0.079l-23.794,13.325c-0.463,0.258-0.684,0.619-0.661,0.977l-0.116,2.799 c-0.007,0.054-0.01,0.109-0.006,0.165l-0.001,0.027h0.002c0.028,0.301,0.23,0.606,0.612,0.847l29.705,18.757 c0.841,0.53,2.241,0.567,3.11,0.082l23.794-13.325c0.46-0.259,0.681-0.616,0.661-0.972H188.006z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.1074,
    y1: 742.2568,
    x2: 36.5814,
    y2: 769.4132,
    gradientTransform: "matrix(1 0 0 1 118.5625 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDF2F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E4EB"
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_60_)",
    d: "M157.809,728.244c-0.842-0.53-2.241-0.569-3.111-0.079l-23.794,13.325 c-0.868,0.486-0.891,1.317-0.048,1.849l29.706,18.762c0.84,0.53,2.242,0.565,3.11,0.079l23.794-13.327 c0.867-0.486,0.891-1.318,0.048-1.851L157.809,728.244z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.0986,
    y1: 718.4561,
    x2: 163.9623,
    y2: 757.105
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFF57A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#54D169"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_61_)",
    d: "M190.294,744.91l-0.011-2.743c0.075-0.388-0.138-0.791-0.639-1.078l-30.45-17.523 c-0.862-0.498-2.261-0.479-3.11,0.044l-23.227,14.293c-0.453,0.278-0.659,0.646-0.623,1.001v2.801 c-0.007,0.055-0.007,0.111,0,0.169v0.026h0.002c0.041,0.302,0.256,0.597,0.646,0.82l30.448,17.523 c0.863,0.498,2.263,0.478,3.111-0.045l23.227-14.292c0.451-0.275,0.656-0.641,0.622-0.996H190.294z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.1523,
    y1: 715.625,
    x2: 156.0497,
    y2: 773.671
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFF57A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#54D169"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_62_)",
    d: "M159.194,723.565c-0.862-0.498-2.261-0.479-3.11,0.044l-23.227,14.293 c-0.849,0.521-0.837,1.354,0.026,1.854l30.448,17.521c0.863,0.496,2.263,0.477,3.111-0.045l23.227-14.291 c0.848-0.522,0.838-1.354-0.026-1.852L159.194,723.565z"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M166.591,739.387c0.068,0.04,0.101,0.083,0.098,0.129c0,0.046-0.034,0.087-0.105,0.126l-6.068,3.537 c-0.063,0.038-0.137,0.055-0.216,0.057c-0.086,0-0.153-0.019-0.215-0.055l-0.434-0.24c-0.061-0.033-0.095-0.072-0.095-0.117 c0.003-0.047,0.036-0.085,0.1-0.123l2.677-1.561l-3.151-1.759l-2.678,1.561c-0.063,0.039-0.138,0.055-0.217,0.057 c-0.086-0.002-0.154-0.019-0.215-0.054l-0.434-0.24c-0.062-0.036-0.089-0.07-0.087-0.116c0.007-0.042,0.041-0.083,0.105-0.117 l6.067-3.539c0.069-0.042,0.138-0.063,0.212-0.065c0.079-0.003,0.147,0.009,0.208,0.043l0.435,0.241 c0.066,0.04,0.1,0.081,0.1,0.128c-0.002,0.045-0.037,0.085-0.106,0.126l-2.584,1.506l3.153,1.758l2.583-1.506 c0.068-0.04,0.139-0.059,0.217-0.063c0.082-0.001,0.153,0.014,0.216,0.049L166.591,739.387z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M159.733,736.144c0.052,0.411-0.248,0.809-0.887,1.184c-0.646,0.375-1.333,0.552-2.055,0.531 c-0.728-0.024-1.43-0.227-2.109-0.604l-1.63-0.909l-2.343,1.364c-0.063,0.036-0.136,0.056-0.215,0.058 c-0.081,0.003-0.148-0.018-0.205-0.048l-0.456-0.256c-0.062-0.033-0.088-0.067-0.088-0.115 c0.008-0.042,0.042-0.08,0.105-0.118l6.068-3.537c0.07-0.041,0.138-0.061,0.212-0.067c0.08-0.002,0.148,0.011,0.209,0.047 l2.294,1.278C159.313,735.331,159.678,735.725,159.733,736.144z M155.394,736.788c0.909,0.51,1.768,0.526,2.583,0.051 c0.391-0.229,0.585-0.471,0.573-0.719c-0.022-0.25-0.262-0.502-0.717-0.754l-1.585-0.887l-2.439,1.426L155.394,736.788 L155.394,736.788z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M171.984,742.975c0.059,0.414-0.246,0.812-0.887,1.184c-0.646,0.377-1.327,0.557-2.056,0.53 c-0.721-0.02-1.423-0.219-2.108-0.6l-1.63-0.911l-2.341,1.364c-0.063,0.038-0.134,0.059-0.212,0.061 c-0.08,0.002-0.148-0.017-0.209-0.051l-0.45-0.251c-0.063-0.034-0.095-0.071-0.089-0.113c0.001-0.046,0.037-0.088,0.1-0.122 l6.068-3.539c0.069-0.041,0.138-0.063,0.217-0.063c0.076-0.006,0.147,0.009,0.21,0.044l2.288,1.274 C171.569,742.165,171.937,742.562,171.984,742.975z M167.643,743.622c0.911,0.507,1.777,0.527,2.589,0.054 c0.391-0.229,0.58-0.472,0.569-0.723c-0.017-0.248-0.257-0.499-0.717-0.756l-1.584-0.882l-2.441,1.423L167.643,743.622 L167.643,743.622z"
  })))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    fill: "#334752",
    cx: 245.777,
    cy: 793.205,
    rx: 27.752,
    ry: 16.116
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3D0D8",
    d: "M271.422,764.388l-12.254-1.008l-8.731-0.781l-17.96,0.558l-11.416,0.784l-1.846,1.231l3.213,26.365 c0,0.01-0.003,0.017-0.003,0.026c0,7.346,10.254,13.301,22.904,13.301c12.261,0,22.27-5.595,22.874-12.626 c0.01-0.014,0.029-0.039,0.029-0.039L271.422,764.388z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDF2F6",
    d: "M271.43,764.875c0,7.562-11.685,13.688-26.101,13.688c-14.418,0-26.101-6.127-26.101-13.688 c0-7.563,11.683-13.692,26.101-13.692C259.745,751.183,271.43,757.312,271.43,764.875z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    fill: "#334752",
    cx: 245.329,
    cy: 764.875,
    rx: 17.011,
    ry: 8.922
  }))), /*#__PURE__*/React.createElement("g", null, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#334752",
    d: "M307.785,700.67c-0.796-0.505-2.12-0.54-2.94-0.078L282.35,713.19c-0.82,0.459-0.841,1.248-0.044,1.748 l28.079,17.73c0.795,0.503,2.12,0.539,2.94,0.078l22.493-12.598c0.82-0.459,0.843-1.247,0.047-1.75L307.785,700.67z"
  })))), /*#__PURE__*/React.createElement("g", null, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#C3D0D8",
    d: "M334.406,717.771l0.085-2.323c0.076-0.328-0.09-0.674-0.504-0.938l-25.172-15.894 c-0.714-0.45-1.9-0.481-2.637-0.068l-20.167,11.292c-0.39,0.222-0.578,0.523-0.558,0.828l-0.099,2.371 c-0.006,0.049-0.009,0.095-0.006,0.141v0.022h0.002c0.023,0.26,0.195,0.515,0.517,0.72l25.176,15.894 c0.715,0.452,1.898,0.485,2.636,0.071l20.167-11.294c0.389-0.219,0.576-0.521,0.559-0.822H334.406z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.8286,
    y1: 710.4922,
    x2: 187.9931,
    y2: 733.5054,
    gradientTransform: "matrix(1 0 0 1 118.5625 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDF2F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E4EB"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_63_)",
    d: "M308.815,698.617c-0.714-0.45-1.9-0.481-2.637-0.068l-20.167,11.292 c-0.735,0.412-0.754,1.119-0.04,1.569l25.175,15.896c0.712,0.452,1.899,0.482,2.635,0.071l20.166-11.295 c0.734-0.413,0.754-1.118,0.04-1.571L308.815,698.617z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.2119,
    y1: 690.3232,
    x2: 314.0283,
    y2: 723.0746
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#59C2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1270E3"
    }
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_64_)",
    d: "M336.344,712.742l-0.01-2.325c0.063-0.331-0.116-0.669-0.54-0.915l-25.805-14.85 c-0.731-0.422-1.918-0.403-2.637,0.035L287.667,706.8c-0.383,0.237-0.559,0.549-0.527,0.851v2.376 c-0.005,0.045-0.005,0.092,0,0.137v0.025h0.002c0.036,0.258,0.217,0.505,0.547,0.695l25.806,14.854 c0.731,0.418,1.917,0.4,2.636-0.041l19.685-12.112C336.197,713.351,336.37,713.04,336.344,712.742L336.344,712.742z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 315.0371,
    y1: 687.9238,
    x2: 307.3228,
    y2: 737.1165
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#59C2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1270E3"
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_65_)",
    d: "M309.989,694.652c-0.731-0.422-1.918-0.403-2.637,0.035L287.667,706.8 c-0.72,0.443-0.709,1.149,0.021,1.569l25.806,14.854c0.731,0.42,1.917,0.4,2.636-0.043l19.685-12.109 c0.718-0.441,0.708-1.148-0.022-1.569L309.989,694.652z"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M309.591,703.712c0.47,0.254,0.784,0.522,0.935,0.806c0.154,0.282,0.165,0.558,0.053,0.817 c-0.112,0.262-0.326,0.491-0.628,0.695l-0.173,0.048l-0.167-0.038l-0.395-0.213l-0.087-0.094 c-0.005-0.033,0.02-0.076,0.068-0.123c0.341-0.311,0.477-0.578,0.405-0.811c-0.057-0.231-0.287-0.456-0.691-0.674 c-0.916-0.496-1.933-0.423-3.041,0.209c-0.158,0.09-0.385,0.226-0.691,0.412c-0.314,0.193-0.548,0.334-0.705,0.437 c-1.024,0.672-1.082,1.256-0.167,1.751c0.399,0.217,0.804,0.333,1.209,0.36c0.41,0.02,0.872-0.073,1.378-0.28 c0.081-0.03,0.151-0.047,0.212-0.046l0.17,0.044l0.393,0.214l0.075,0.093l-0.066,0.099c-0.336,0.186-0.728,0.321-1.178,0.406 c-0.445,0.081-0.918,0.085-1.42,0.016c-0.5-0.071-0.987-0.233-1.459-0.486c-0.699-0.379-1.033-0.786-0.999-1.23 c0.029-0.444,0.379-0.88,1.05-1.323c0.148-0.096,0.391-0.244,0.728-0.449c0.343-0.21,0.587-0.355,0.749-0.452 c0.726-0.408,1.467-0.638,2.238-0.682C308.155,703.168,308.89,703.334,309.591,703.712z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M319.506,709.065c0.416,0.228,0.683,0.464,0.827,0.715c0.144,0.252,0.173,0.489,0.095,0.705 c-0.076,0.228-0.219,0.412-0.441,0.556l-0.177,0.052l-0.163-0.033l-0.399-0.214l-0.075-0.089l0.043-0.117 c0.205-0.164,0.276-0.351,0.21-0.568c-0.071-0.211-0.266-0.412-0.6-0.59c-0.355-0.194-0.718-0.303-1.075-0.327 c-0.358-0.026-0.684,0.051-0.967,0.226c-0.192,0.117-0.3,0.242-0.321,0.368c-0.028,0.124,0.012,0.273,0.124,0.441 c0.112,0.17,0.297,0.393,0.563,0.679c0.315,0.322,0.541,0.594,0.665,0.813c0.12,0.219,0.153,0.424,0.076,0.608 c-0.071,0.191-0.258,0.376-0.566,0.562c-0.523,0.321-1.112,0.472-1.781,0.438c-0.669-0.025-1.318-0.213-1.962-0.558 c-0.433-0.236-0.74-0.479-0.916-0.742c-0.172-0.259-0.229-0.505-0.163-0.737c0.071-0.235,0.231-0.439,0.493-0.607l0.168-0.044 l0.163,0.034l0.389,0.211c0.094,0.05,0.107,0.116,0.036,0.204c-0.188,0.167-0.248,0.362-0.194,0.586 c0.06,0.226,0.289,0.449,0.71,0.676c0.443,0.242,0.864,0.374,1.256,0.392c0.383,0.02,0.727-0.061,1.018-0.239 c0.193-0.116,0.288-0.239,0.298-0.372c0.016-0.134-0.04-0.284-0.162-0.458c-0.119-0.17-0.331-0.409-0.625-0.725 c-0.282-0.289-0.477-0.542-0.58-0.762c-0.1-0.212-0.109-0.412-0.033-0.598c0.08-0.19,0.275-0.379,0.583-0.565 c0.302-0.186,0.647-0.305,1.03-0.368c0.388-0.059,0.796-0.051,1.224,0.018C318.697,708.711,319.111,708.853,319.506,709.065z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M314.601,706.416c0.411,0.222,0.684,0.465,0.828,0.716c0.138,0.248,0.167,0.486,0.095,0.707 c-0.076,0.225-0.225,0.404-0.448,0.553l-0.171,0.053l-0.169-0.037l-0.393-0.212l-0.077-0.087l0.039-0.121 c0.211-0.16,0.282-0.348,0.216-0.564c-0.07-0.214-0.268-0.413-0.601-0.59c-0.354-0.192-0.719-0.302-1.074-0.33 c-0.357-0.024-0.682,0.055-0.966,0.229c-0.192,0.116-0.3,0.239-0.329,0.364c-0.021,0.129,0.018,0.276,0.131,0.443 c0.107,0.165,0.295,0.394,0.563,0.68c0.315,0.323,0.538,0.591,0.664,0.813c0.121,0.218,0.146,0.418,0.077,0.608 c-0.071,0.189-0.259,0.374-0.566,0.564c-0.523,0.316-1.12,0.465-1.782,0.436c-0.667-0.026-1.323-0.215-1.967-0.563 c-0.433-0.233-0.735-0.477-0.912-0.737c-0.17-0.261-0.229-0.507-0.163-0.737c0.072-0.236,0.233-0.438,0.496-0.609l0.166-0.043 l0.163,0.032l0.39,0.211c0.093,0.051,0.107,0.118,0.037,0.208c-0.19,0.164-0.246,0.359-0.192,0.583 c0.052,0.224,0.286,0.45,0.704,0.675c0.448,0.242,0.862,0.373,1.253,0.39c0.385,0.021,0.728-0.063,1.02-0.239 c0.19-0.114,0.292-0.236,0.304-0.37c0.015-0.132-0.041-0.282-0.165-0.455c-0.117-0.171-0.329-0.411-0.624-0.726 c-0.283-0.292-0.482-0.548-0.581-0.76c-0.098-0.215-0.114-0.417-0.037-0.604c0.086-0.188,0.28-0.375,0.59-0.563 c0.302-0.186,0.642-0.31,1.028-0.367c0.383-0.063,0.792-0.055,1.222,0.02C313.792,706.062,314.206,706.205,314.601,706.416z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.e5274e8f4bd516059fbc9e1d7430102b.svg";
export { ForwardRef as ReactComponent };